import styles from "./AppointmentType.module.scss"
import cx from "classnames"
import React from "react"

const AppointmentType = ({ field, appointmentType, methods, className }) => {
  if (!appointmentType) return null

  const { register } = methods
  const { name } = field
  const { name: appointmentName, duration, price } = appointmentType

  return (
    <div className={cx(styles.appointmentType, className)}>
      <input
        className={cx(styles.input, "peer")}
        type="radio"
        value={JSON.stringify(appointmentType)}
        {...register(name)}
      />

      <label className="w-full text-center rounded-md bg-white p-3 peer-hover:text-white peer-checked:text-white peer-hover:bg-brand-turquoise peer-checked:bg-brand-turquoise">
        {appointmentName && <div>{appointmentName}</div>}
        <div className="text-xs w-fit flex items-center mx-auto">
          {duration && <span className="mr-4 last:mr-0">{duration} Min.</span>}
          {price && <span>{price} €</span>}
        </div>
      </label>
    </div>
  )
}

export default AppointmentType
